import {
  clearExceptionDetails,
  fetchExceptionFail,
  fetchExceptionStarted,
  fetchExceptionSuccess
} from '../../../reducer/services/ExceptionSearchReducer';
import { getExceptionList } from '../../actionType/services/ServiceActionTypes';
import {
  ClearException,
  FetchExceptionFailure,
  FetchExceptionFailurePayload,
  FetchExceptionRequest,
  FetchExceptionStarted,
  FetchExceptionSuccess,
  FetchExceptionSuccessPayload
} from '../../types/exceptions/FetchExceptionTypes';

export const fetchExceptionRequest = (exceptionName: string, status: string): FetchExceptionRequest => ({
  type: getExceptionList.FETCH_EXCEPTION_REQUEST,
  exceptionName,
  status
});

/**
 * Fetch exception started saga action
 * @returns event started action
 */
export const getExceptionStarted = (): FetchExceptionStarted => ({
  type: fetchExceptionStarted.type
});

/**
 * Fetch exception success saga action
 * @param payload :Event data
 * @returns success action
 */
export const getExceptionSuccess = (
  payload: FetchExceptionSuccessPayload
): FetchExceptionSuccess => ({
  type: fetchExceptionSuccess.type,
  payload
});

/**
 * Fetch Exception Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getExceptionFailure = (
  payload: FetchExceptionFailurePayload
): FetchExceptionFailure => ({
  type: fetchExceptionFail.type,
  payload
});

/**
 * Clear Exception saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearExceptions = (): ClearException => ({
  type: clearExceptionDetails.type
});
